import isNull from 'lodash/isNull';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React from 'react';

import { KeyCodes } from '../../../constants/App';
import QATags from '../../../constants/QATags';
import { createBEM } from '../../../lib/utils/css';

import './EditableTitleT3.scss';

class EditableTitleT3 extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onUpdate: PropTypes.func,
    isEditable: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    titleValidator: PropTypes.func,
    onSave: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    qaTag: PropTypes.oneOf(values(QATags)),
  };

  state = {
    title: null,
    warning: null,
  };

  getWidth = () => {
    const content = this.props.title || '';

    // Get current font family and size
    let fontProperties;
    if (document.getElementsByClassName('EditableTitleT3__input')[0]) {
      const inputEl = document.getElementsByClassName('EditableTitleT3__input')[0];
      const font = window.getComputedStyle(inputEl, null).getPropertyValue('font-family');
      const size = window.getComputedStyle(inputEl, null).getPropertyValue('font-size');
      fontProperties = `${size} ${font}`;
    }

    // Use a canvas element to calculate the width of the title text
    const canvas = this.canvas || (this.canvas = document.createElement('canvas'));
    const context = canvas.getContext('2d');
    let paddedWidth = 52;
    if (context) {
      // cspell:disable-next-line
      context.font = fontProperties || '24px Avenir Next';
      const metrics = context.measureText(content);
      paddedWidth += Math.floor(metrics.width);
    }

    return `${paddedWidth}px`;
  };

  onKeyPress = event => {
    // if the key is ENTER, cause an onBlur
    if (event.which === KeyCodes.ENTER) {
      this.editableTitleInput.blur();
      event.preventDefault();
    }
  };

  onChange = event => {
    if (this.props.isEditable) {
      this.setState({ title: event.target.value });
      const warning = this.props.titleValidator && this.props.titleValidator(event.target.value);
      warning ? this.setState({ warning }) : this.setState({ warning: null });

      if (this.props.onUpdate) {
        this.props.onUpdate(event.target.value);
      }
    }
  };

  onBlur = event => {
    if (this.props.isEditable && !this.state.warning) {
      this.props.onSave(event.target.value);
    }
    this.setState({ title: null, warning: null });
  };

  onFocus = event => {
    if (this.props.isEditable && this.props.title === this.props.placeholder) {
      event.target.select();
    }
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  render() {
    const inputClassnames = createBEM('EditableTitleT3__input', {
      editable: this.props.isEditable,
      error: this.state.warning,
    });
    return (
      <div className='EditableTitleT3'>
        <input
          ref={editableTitleInput => {
            this.editableTitleInput = editableTitleInput;
          }}
          className={inputClassnames}
          maxLength={this.props.maxLength}
          value={isNull(this.state.title) ? this.props.title : this.state.title}
          onKeyPress={this.onKeyPress}
          onChange={this.onChange}
          onFocus={this.onFocus}
          style={{ width: this.getWidth() }}
          disabled={!this.props.isEditable}
          onBlur={this.onBlur}
          placeholder={this.props.placeholder}
          data-qa={this.props.qaTag}
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={this.props.isEditable && this.props.title === this.props.placeholder}
        ></input>
        {this.state.warning && (
          <div className='EditableTitleT3__errorBox'> {this.state.warning} </div>
        )}
      </div>
    );
  }
}

export default EditableTitleT3;
